import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'whatwg-fetch';
import { printTicketId } from 'src/utils/utilMajorEntity';

import data_priority from 'src/data/priority';
import SubNavBar from '../components/SubNavBar';
import withAuth from 'src/hoc/withAuth';

const apiDealShow = '/api/deal/show/';
const linkToTicket = '/dashboard/ticket/';
const linkToUser = '/dashboard/user/';

class AppTicket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appViewNavExtended: false, // Extend the menu behind the appViewNav
      entity: undefined, // products displayed inside the table
      dataTicket: undefined,
      customer: {
        id: undefined,
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleAppViewNavExtended = this.toggleAppViewNavExtended.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      // check if id supplied in the route
      const paramsID = this.props.match.params.id;

      let queryURL = apiDealShow;
      let graphQL =
        '{ deal(id:' +
        paramsID +
        '){ id,  name, customer{ id }, stepSupport{ tickets{ id, subject, state, closed, dateCreate, priority, supportEmployee{ user{ id, username } } } } } }';
      queryURL += graphQL;
      this.props
        .authFetch(queryURL, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          method: 'GET',
        })
        .then((resp) => resp.json())
        .then(
          function (data) {
            if (data['data']['deal']['stepSupport']) {
              this.setState({
                dataTicket: data['data']['deal']['stepSupport']['tickets'].reverse(),
                customer: data['data']['deal']['customer'],
              });
            }
          }.bind(this)
        )
        .catch(
          function (error) {
            console.log('error fetch ticket list');
          }.bind(this)
        );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.componentDidMount();
    }
  }

  toggleAppViewNavExtended() {
    this.setState({
      appViewNavExtended: !this.state.appViewNavExtended,
    });
  }

  render() {
    const { dataTicket } = this.state;

    let noTicket =
      this.state.dataTicket !== undefined && this.state.dataTicket.length === 0 ? <span>Aucun ticket.</span> : '';

    return (
      <div id='appView' className='div-entity'>
        <SubNavBar
          toggleAppViewNavExtended={this.toggleAppViewNavExtended}
          goBack={this.props.history.goBack}
          appViewNavExtended={this.state.appViewNavExtended}
          title='Historique Tickets'
        />

        <div id='appViewContent'>
          <div className='helper helper-panel-legend'>
            <span className='helper-label-legend lvl2'>À traiter</span>
            <span className='helper-label-legend lvl1'>En cours de résolution</span>
          </div>
          <br />

          <table className='table'>
            <thead>
              <tr>
                <th>Sujet</th>
                <th>Créé le</th>
                <th>Priorité</th>
                <th>Créateur</th>
              </tr>
            </thead>
            <tbody>
              {dataTicket ? (
                dataTicket.map((data, i) => (
                  <tr
                    key={i}
                    className={'' + (data.closed ? '' : data.state === 1 ? 'marked-negative  ' : 'marked-positive ')}
                  >
                    <td>
                      <Link to={linkToTicket + data.id}>
                        <span>{printTicketId(data.id) + data.subject} </span>
                      </Link>
                    </td>
                    <td>
                      <span>{moment(data.dateCreate).format('DD-MM-YY à HH:mm')}</span>
                    </td>
                    <td>
                      <span>{data.priority + '-' + data_priority[data.priority].fr}</span>
                    </td>
                    <td>
                      {data.supportEmployee ? (
                        <Link to={linkToUser + data.supportEmployee.user.id}>
                          <span>{'@' + data.supportEmployee.user.username}</span>
                        </Link>
                      ) : (
                        <span>Non-renseigné</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <li className='list-group-item'>Chargement...</li>
              )}
            </tbody>
          </table>
          {noTicket}
        </div>
      </div>
    );
  }
}

export default withAuth(AppTicket);
